// The missing-permission stamp of the agent chat's DM-ledger replies (AgentStreamView), fed by the
// same frame and rows ChatMessage reads.
import type { WorkSummary } from "./core/types.js";

export interface MissingNote {
  grants: readonly string[];
  cyboId: string;
  askerUserId?: string;
}

const noteOf = (work: WorkSummary | undefined): MissingNote | undefined =>
  work?.missingPermission?.length && !work.askerErased
    ? {
        grants: work.missingPermission,
        cyboId: work.cyboId,
        ...(work.askerUserId ? { askerUserId: work.askerUserId } : {}),
      }
    : undefined;

class RowWork {
  #rows = $state<Record<string, MissingNote>>({});

  clear(): void {
    this.#rows = {};
  }

  get(id: string | null | undefined): MissingNote | undefined {
    return id ? this.#rows[id] : undefined;
  }

  setFromFrame(messageIds: readonly string[], work: WorkSummary): void {
    const note = noteOf(work);
    if (!note) return;
    for (const id of messageIds) this.#rows[id] = note;
  }

  setFromMessages(messages: readonly { id: string; workSummary?: WorkSummary }[]): void {
    for (const m of messages) {
      const note = noteOf(m.workSummary);
      if (note) this.#rows[m.id] = note;
    }
  }
}

export const rowWork = new RowWork();
